/* Ability Warehouse - aw-fit-result loader (v33 r2).
   The product fit-check module is delivered in byte-identical parts (aw-fit-result-p1..p4.js) that concatenate to the
   original source; this loader fetches them synchronously and runs them as one inline script, so window.AWFitProduct
   is defined before assets/aw-choose.js initialises. Falls back silently (round degrades) if anything is blocked. */
(function () {
  'use strict';
  var cs = document.currentScript;
  var base = (cs && cs.src ? cs.src : '').replace(/[^/]*$/, '');
  if (!base) return;
  var parts = ['aw-fit-result-p1.js', 'aw-fit-result-p2.js', 'aw-fit-result-p3.js', 'aw-fit-result-p4.js'];
  var code = '', ok = true;
  for (var i = 0; i < parts.length; i++) {
    try {
      var x = new XMLHttpRequest();
      x.open('GET', base + parts[i], false);
      x.send(null);
      if (x.status >= 200 && x.status < 400) code += x.responseText; else { ok = false; break; }
    } catch (e) { ok = false; break; }
  }
  /* v33 r3 fix - restore the renderResult() opening that was lost when the source was split into parts: the
     committed aw-fit-result-p2.js ends at "function renderResult() {" and p3 resumes mid-body, so the result
     screen's own J (judge), j/v/checks, vv (auto-selected size) and h (verdict header) were never declared.
     J stayed null, "See the verdict" threw "Cannot read properties of null (reading 'auto')" and nothing showed.
     We reinsert exactly those lines into the concatenated source, only when they are missing. */
  if (ok && code && code.indexOf('function renderResult() {') >= 0 && !/function renderResult\(\)\s*\{\s*J\s*=\s*judge\(\)/.test(code)) {
    code = code.replace('function renderResult() {',
      'function renderResult() {\n'
      + '      J = judge();\n'
      + '      var j = J.cur, v = j.v, checks = j.checks;\n'
      + '      var vv = J.auto ? variantById(curVid) : null;\n'
      + '      lastVerdict = v;\n'
      + '      var h = \'<div class="fit-v fit-v--\' + v + \'"><span class="fit-v__ic" aria-hidden="true">\' + VICON[v] + \'</span><span class="fit-v__t"><b>\' + esc(VLABEL[v]) + \'</b><span>\' + esc(reasonOf(v, checks)) + \'</span></span></div>\';');
  }
  if (ok && code) {
    try {
      var s = document.createElement('script');
      s.textContent = code;
      (document.head || document.documentElement).appendChild(s);
      s.parentNode.removeChild(s);
    } catch (e) {}
  }
})();
